const getInitials = (value?: string) => {
	if (!value) return "NA";
	return value
		.trim()
		.split(/\s+/)
		.map((word) => word[0]?.toUpperCase())
		.join("")
		.slice(0, 2);
};

function checkImage(url: string) {
	return new Promise((resolve) => {
		const img = new Image();

		img.onload = () => resolve({ status: "loaded", url });
		img.onerror = () => resolve({ status: "error", url });

		img.src = url;
	});
}

async function urlToFile(url: string) {
	const fileName = url.split("/").pop();

	if (!fileName?.length) return;

	const extension = fileName.split(".").pop();

	if (!extension?.length) return;

	let mimeType;
	switch (extension.toLowerCase()) {
		case "jpg":
		case "jpeg":
			mimeType = "image/jpeg";
			break;
		case "png":
			mimeType = "image/png";
			break;
		case "gif":
			mimeType = "image/gif";
			break;
		case "webp":
			mimeType = "image/webp";
			break;
		default:
			mimeType = "application/octet-stream";
	}

	const response = await fetch(url);
	const blob = await response.blob();

	return new File([blob], fileName, { type: mimeType });
}

export { getInitials, urlToFile, checkImage };
